// CLASSES
import AppConfig from "@classes/AppConfig";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	if (state.fields.customer_autogiro.options[0].checked) {
		const replacedAccountNo = state.fields.customer_account_bank_no.split(" ").join("");
		if (replacedAccountNo.length <= 5 || state.fields.customer_account_bank.length === 0) {
			return false;
		}
	}
	else if (!state.fields.customer_autogiro.options[1].checked) {
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/alfakraft/Autogiro.fulfillment.js